import { render, staticRenderFns } from "./_boxImages.vue?vue&type=template&id=8b59a534"
import script from "./_boxImages.vue?vue&type=script&lang=js"
export * from "./_boxImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports